export const BRAND_LOGO_IMAGE_WIDTH = 100
export const BRAND_LOGO_IMAGE_HEIGHT = 40
export const BRAND_KEY = process.env.NEXT_PUBLIC_BRAND?.toLowerCase() || ''
